import type { ApiEndpointBuilder } from "../apiEndpointHelpers";
import type { MessagingTemplateFolderContext } from "./adminV2MessagingTemplateFolderEndpoints";

import type { AdminV2MessageTemplateLibraryCategory } from "@/types/adminV2/messaging";

export type MessagingTemplateDestinationCategory = Exclude<
  AdminV2MessageTemplateLibraryCategory,
  "system"
>;
export interface MessagingTemplatePlacement {
  templateId: string;
  organisationId: string | null;
  libraryCategory: AdminV2MessageTemplateLibraryCategory;
  folderId: string | null;
  version: number;
}
export interface MessagingTemplatePlacementRequest {
  /** Cache ownership only, never sent to the API. */
  ownerKey: string;
  templateId: string;
}
export interface MoveMessagingTemplate extends MessagingTemplatePlacementRequest {
  scope: MessagingTemplateFolderContext["scope"];
  libraryCategory: MessagingTemplateDestinationCategory;
  folderId: string | null;
  expectedVersion: number;
}
const placementUrl = (templateId: string) =>
  `/admin/v2/messaging/templates/${encodeURIComponent(templateId)}/library-placement`;

export const buildAdminV2MessagingTemplatePlacementEndpoints = (
  builder: ApiEndpointBuilder,
) => ({
  getAdminV2MessagingTemplatePlacement: builder.query<
    MessagingTemplatePlacement,
    MessagingTemplatePlacementRequest
  >({
    query: ({ templateId }) => ({ url: placementUrl(templateId) }),
    providesTags: (_result, _error, { templateId }) => [
      { type: "AdminV2MessagingTemplates", id: `PLACEMENT:${templateId}` },
    ],
    keepUnusedDataFor: 0,
  }),
  moveAdminV2MessagingTemplate: builder.mutation<
    MessagingTemplatePlacement,
    MoveMessagingTemplate
  >({
    query: ({ templateId, libraryCategory, folderId, expectedVersion }) => ({
      url: placementUrl(templateId),
      method: "PUT",
      data: { libraryCategory, folderId, expectedVersion },
    }),
    invalidatesTags: (_result, _error, { templateId, scope }) => [
      { type: "AdminV2MessagingTemplates", id: "LIST" },
      { type: "AdminV2MessagingTemplates", id: templateId },
      { type: "AdminV2MessagingTemplates", id: `PLACEMENT:${templateId}` },
      {
        type: "AdminV2MessagingTemplates",
        id: `FOLDERS:${scope.kind === "global" ? "global" : scope.organisationId}`,
      },
    ],
  }),
});
